import { render } from "./CardPage.vue?vue&type=template&id=cbfc2662&scoped=true"
import script from "./CardPage.vue?vue&type=script&lang=js"
export * from "./CardPage.vue?vue&type=script&lang=js"

import "./CardPage.vue?vue&type=style&index=0&id=cbfc2662&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cbfc2662"

export default script